/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type MenuReorderRailOrdersQueryVariables = Types.Exact<{
  input: Types.OrdersInputV2;
  restaurantId: Types.Scalars['Int']['input'];
}>;

export type MenuReorderRailOrdersQuery = {
  readonly __typename?: 'Query';
  readonly ordersV2:
    | {
        readonly __typename: 'OrdersResponseSuccess';
        readonly orders: ReadonlyArray<{
          readonly __typename: 'Order';
          readonly id: string;
          readonly wantedTime: string;
          readonly restaurant: {
            readonly __typename: 'Restaurant';
            readonly id: string;
            readonly name: string;
            readonly slug: string;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename: 'LineItem';
            readonly id: string;
            readonly customName: string | null;
            readonly canReorderAtRestaurant: boolean;
            readonly dressingMode: Types.DressingMode;
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly __typename?: 'MixedDressingDetails';
              readonly weight: Types.DressingWeight;
              readonly ingredientId: string;
            }>;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
            }>;
            readonly product: {
              readonly __typename: 'Product';
              readonly id: string;
              readonly name: string;
              readonly isCustom: boolean;
              readonly categoryName: string;
              readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
              readonly ingredients: ReadonlyArray<{
                readonly __typename: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              }>;
            };
          }>;
        }>;
      }
    | { readonly __typename: 'ValidationError' };
};

export const MenuReorderRailOrdersDocument = gql`
  query menuReorderRailOrders($input: OrdersInputV2!, $restaurantId: Int!) {
    ordersV2(input: $input) {
      __typename
      ... on OrdersResponseSuccess {
        orders {
          id
          __typename
          wantedTime
          restaurant {
            id
            __typename
            name
            slug
          }
          lineItems {
            id
            __typename
            customName
            canReorderAtRestaurant(restaurantId: $restaurantId)
            dressingMode
            mixedDressingDetails {
              weight
              ingredientId
            }
            addedIngredients {
              id
              __typename
              name
              kind
            }
            removedIngredients {
              id
              __typename
              name
              kind
            }
            product {
              id
              __typename
              name
              isCustom
              categoryName
              asset {
                url
              }
              ingredients {
                id
                __typename
                name
                kind
              }
            }
          }
        }
      }
    }
  }
`;

export function useMenuReorderRailOrdersQuery(
  options: Omit<Urql.UseQueryArgs<MenuReorderRailOrdersQueryVariables>, 'query'>,
) {
  return Urql.useQuery<MenuReorderRailOrdersQuery, MenuReorderRailOrdersQueryVariables>({
    query: MenuReorderRailOrdersDocument,
    ...options,
  });
}
